module.exports = __webpack_public_path__ + "static/media/Emory.cc883e9f.png";